import React, { useState } from "react";
import { VbzModal, VbzButton } from "@smiles/voebiz-ui-kit";
import { useTranslation } from "react-i18next";
import { ModalBody, ModalFooter } from "reactstrap";

import { useTransactions } from "../../context/TransactionsContext";

const LegacyUserModal = () => {
  const { t } = useTranslation("legacyUserModal");
  const [success, setSuccess] = useState(false);
  const { state, dispatch } = useTransactions();

  const sendTransaction = () => setSuccess(true);

  const closeModal = () => {
    dispatch({
      type: "MODAL",
      modals: { filterModalOpen: false, threeYearsModalOpen: false, legacyUserModalOpen: false },
    });
  };

  return (
    <VbzModal isOpen={state.modals.legacyUserModalOpen} className="three-years-modal" toggle={closeModal}>
      <ModalBody>
        <h4 className="three-years-modal__title-legacy">{t(`${success ? "success" : "default"}.title`)}</h4>

        <p className="three-years-modal__body">{t(`${success ? "success" : "default"}.body`)}</p>
      </ModalBody>

      <ModalFooter className="three-years-modal__footer-legacy">
        {success ? (
          <VbzButton className="three-years-modal__btn" text={t("success.understood")} onClick={closeModal} />
        ) : (
          <>
            <VbzButton
              className="three-years-modal__btn"
              text={t("default.sendTransaction")}
              onClick={sendTransaction}
            />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="three-years-modal__link">
              {t("default.goToMyData")}
            </a>
          </>
        )}
      </ModalFooter>
    </VbzModal>
  );
};

export default LegacyUserModal;
